var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0_4_7)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_4_7",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4_7",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4_7",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADP0lEQVR4nO2YO2gUQRjH1yQeyqExSEIkJ4pGUSQ+UAsbRRCLaGmhWB2iEh9RCEZFQSutLI1gKVhoEIwawTKNoqX4AkWFFOKpMYmvGB8/mdy33LC3e9ndm929w/xhOW7m+76d385887KsKf2HAuqBS8Ag8Jfy9BN4BLTHDdEIPCYatScBoX4XG4g5HeiSmA/NtDQYRKPB2CmJO2Yqph+IZ0BzBO+YkOm4xnoCyAC9wKg8N4AlsYIYgvhEsVRZSywgJnKCfE8o3VYNl+eOlF2LHMRUYpMfSuhfH5gvZcORgpicnYARiZOJFcT0FEs+sZHhlJGnX8p6IwGJYp0AlgIfPZK91WFrb3WmVRSEFrtFJbYMsxGZAFpd7P7I+2srdrHzI+C3tKGuaiGUgHFpR8qKazgBi4CjwDlgJ9Ak5RslmdOBGmNN+I5JW2ZEDqESETgD/HIk73egB/gq/ztDgHwT33QcPXFKa7waiheA6w6wnjAzD4U1Z07UEMr3h/he0ZMS2AAMSd2eoBBKQE78m6PeAG7Vvvpcl/odUvc0SFyXHKm3It4Atom/Wrhme+RPTupnBoy9UGKPe06/ZSR20ewBvJY4WQ+fQblMSAU8Hd6SuHdNQzQBr4BNjvIOifXC2VhgrfTGQECIPomZc70DABrKSOyL4nfVUV4ns5VSl6NuhTQmGxKizcvwckiIWpkK1ddd4FK/Rdv4NTjqlvsZVviFEOM3YrjaL4Qj8V6WsBkQm2NBYgeGEIcHYtxd0tA9r5TelbDZLTb3y4RY6cdpuwwP9XQEfOFzedk2j/rNUj8aEuKDLwjHLGPDHAjgl7V7xW0mkW1IyeFnDMKWAggKo/JKOx+8l1W7Rq0twHntNHcyFogwMMA87Xj6hYKGZZdrq3+yQxDFEKuscuWAOTiJ7Vm5OEgDh4AnGoBK0tOJQISEqXH8n6Vf6yQGYQvYq8EctgxLIG4KxJDauph+hxdMZ1VCRAWTCIQtYJ8JGBeIdVbcokyYioDwgDlihYP4nChEWJiKhLAF7PcDU9EQLjBKx6sSwgPmRFVC2FJDSxtm3XLg6tOOuWusahEFGF2qJ9Zb1SZgF/BW7qvuAcuSbtOUrAT0D9xLzFdTZu11AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.343b2d952da573983ed972ed5f18890b.svg";
export { ForwardRef as ReactComponent };